"use client";

import { c as _c } from "react/compiler-runtime";
import { enUSMessages, LocaleProvider } from "@opensea/i18n";
import { IntlProvider as UseIntlProvider } from "use-intl";
export function IntlProvider(t0) {
  const $ = _c(6);
  const {
    children,
    locale: t1
  } = t0;
  const locale = t1 === undefined ? "en-US" : t1;
  let t2;
  if ($[0] !== children || $[1] !== locale) {
    t2 = <UseIntlProvider locale={locale} messages={enUSMessages}>{children}</UseIntlProvider>;
    $[0] = children;
    $[1] = locale;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== locale || $[4] !== t2) {
    t3 = <LocaleProvider value={locale}>{t2}</LocaleProvider>;
    $[3] = locale;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}